import React, { useState } from "react";
import { observer } from "mobx-react";
import { ComboBox } from "@fluentui/react";
import { store } from "../../store";
import { LengthUnit } from "../../api";

export const FormUpdateDefaultLengthUnit = observer(() => {
    const publicSettingsId = store.servicePublicSettings.publicSetting?.id;

    const [isLoading, setIsLoading] = useState(false);
    const updateDefaultLengthUnit = async (
        publicSettingId: string,
        defaultLengthUnit: LengthUnit,
    ): Promise<void> => {
        setIsLoading(true);
        try {
            await store.repositoryPublicSettings.update(publicSettingId, { defaultLengthUnit });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ComboBox
            disabled={isLoading}
            label={store.i18n.t("page.systemWide.defaultLengthUnit.label")}
            options={[
                {
                    key: LengthUnit.METERS,
                    text: store.i18n.t("page.systemWide.defaultLengthUnit.meters"),
                },
                {
                    key: LengthUnit.FEET,
                    text: store.i18n.t("page.systemWide.defaultLengthUnit.feet"),
                },
            ]}
            selectedKey={store.servicePublicSettings.publicSetting?.defaultLengthUnit}
            onChange={(_, option) => {
                if (publicSettingsId && option?.key) {
                    updateDefaultLengthUnit(publicSettingsId, option?.key as LengthUnit);
                }
            }}
        />
    );
});
